import { createResource } from 'redux-rest-resource'
import { remove, includes, map, get, cloneDeep } from 'lodash'
import { baseURL } from './'

export const { types, actions, rootReducer } = createResource({
  name: 'event',
  url: `${baseURL}`,
  credentials: 'include',
  actions: {
    fetch: { method: 'GET', gerundName: 'fetching', url: './events' },
    get: {
      method: 'GET',
      gerundName: 'getting',
      url: './events/:id',
      transformResponse: ({ body: event, ...response }) => {
        // Affectation des valeurs transformÃ©es pour le formulaire
        event.impactant = includes(['BASIN', 'TANK'], get(event, 'eventType'))
        event.target = includes(['BASIN', 'TANK'], get(event, 'eventType'))
          ? get(event, 'eventType')
          : null

        if (get(event, 'target') === 'BASIN') {
          event.basinElement = get(event, 'element')
        } else if (get(event, 'target') === 'TANK') {
          event.tankElement = get(event, 'element')
        }

        return { body: event, ...response }
      }
    },
    update: {
      method: 'PUT',
      gerundName: 'updating',
      url: './events/:id',
      assignResponse: true,
      reduce: ({ items, item, ...state }, { context, body, status }) => {
        const isUpdating = status === 'pending'

        // DonnÃ©es Ã  stocker dans le reducer
        // Lors de la mise Ã  jour stocker les donnÃ©es sources
        // Sinon stocker les donnÃ©es reÃ§ues par le serveur
        const updated = isUpdating ? context : body

        // Mise Ã  jour de l'Ã©lÃ©ment
        const updatedItem =
          get(updated, 'id') === get(item, 'id')
            ? isUpdating
              ? { ...item, ...updated }
              : updated
            : item

        // Mise Ã  jour de la liste de tous les Ã©lÃ©ments avec l'Ã©lÃ©ment Ã  jour
        const updatedItems = map(items, item =>
          get(updated, 'id') === get(item, 'id') ? updatedItem : item
        )

        return { ...state, items: updatedItems, item: updatedItem, isUpdating }
      }
    },
    create: { method: 'POST', gerundName: 'creating', url: './events' },
    archive: {
      method: 'PATCH',
      gerundName: 'archiving',
      url: './events/:id/archive',
      reduce: ({ items, ...state }, { body: archived }) => {
        // Suppression des donnÃ©es archivÃ©es du store
        remove(items, { id: get(archived, 'id') })

        return { ...state, items: cloneDeep(items) }
      }
    },
    archiveMany: {
      isArray: true,
      alias: 'archive',
      method: 'PATCH',
      gerundName: 'archiving',
      url: './events/archive',
      reduce: ({ items, ...state }, { body: archived }) => {
        // Suppression des donnÃ©es archivÃ©es du store
        remove(items, ({ id }) => includes(map(archived, 'id'), id))

        return { ...state, items: cloneDeep(items) }
      }
    },
    delete: { method: 'DELETE', gerundName: 'deleting', url: './events/:id' },
    deleteMany: {
      isArray: true,
      alias: 'delete',
      method: 'DELETE',
      gerundName: 'deleting',
      url: './events/delete'
    }
  }
})
